export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    if (import.meta.client) {
      document.body.focus();

      const handleFirstTab = (e: KeyboardEvent) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          const skipLink = document.querySelector('.skip-link') as HTMLElement;
          if (skipLink) {
            skipLink.focus();
            e.preventDefault();
          }
          window.removeEventListener('keydown', handleFirstTab);
        }
      };

      window.addEventListener('keydown', handleFirstTab);
    }
  });
});
